import $ from 'jquery';

export default function productChild() {
        $(".button-read-more-child").mouseover(function () {
            $(this).parent().prev().find(".item-link-active").addClass("show");
        });
        $(".button-read-more-child").mouseout(function () {
            if(window.innerWidth > 992) {
                $(this).parent().prev().find(".item-link-active").removeClass("show");
            }
        });
        if(window.innerWidth <= 992) {
            $(".item-link-active").addClass("show");
        }


}